/*
 * Created by alex@hackerbay.com on 10.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

const MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT = "DD.MM.";
const MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP = "dd, DD.MM.";
const MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_ONLY_WEEKDAY = "dd";
const statusBoxTimeUntilAppointmentTextHelper = function(days){
    if(days > 7){
        return {
            textResource: "x_weeks_to_go",
            adjustedDayCount: Math.floor(days / 7)
        }
    }else if(days > 0){
        return {
            textResource: "x_days_to_go",
            adjustedDayCount: days
        };
    }
    return "appointment_today";
};
export {
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT,
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP,
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_ONLY_WEEKDAY,
    statusBoxTimeUntilAppointmentTextHelper
}